import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { BrowserRouter } from 'react-router-dom';
import EmailProvider from './features/contact/contexts/EmailContext';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <EmailProvider>
          <App />
        </EmailProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
